import React from 'react';
import {
    Form,
    Input,
    Select,
    Col,
    Row,
    message,
    DatePicker,
    Table, Button, InputNumber, Radio
} from 'antd';
import Cookies from 'js-cookie';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom } from '../../../../axios';
import {formatTime} from "../../../../utils";
import CollectionScheduleDetailedInfo from '../../components/CollectionScheduleDetailedInfo';

import {paymentDate, totalNumberPeriods} from "../../../../axios/dictionaries";
import moment from "moment";


const Option = Select.Option;


class Page extends React.Component {

    constructor() {
        super();
        this.state = {
            loading: false,
            merchantId:0,
            title: "租金汇集计划",
            columns:[],
            dataSource:[],
            showCollectionScheduleDetailedInfoModal:false,
            data: {
                shortName:'',
                houseLayout: [],
                titleList: [],
            },
        }
    }

    render() {
        const modalFooter = {}
        modalFooter.footer = <Button onClick={this.handleCancel}>关闭</Button>
        let { visible, form: { getFieldDecorator, setFieldsValue } } = this.props;
        let {
            loading,
            title,
            data,
            columns,
            showCollectionScheduleDetailedInfoModal,
            dataSource
        } = this.state;
        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            {...modalFooter}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    <Row>
                        <Col span={24}>
                            <DetailTitle title="租金汇集明细基础信息" />
                            <CustomRow divider>
                                <CustomCol label="商户简称">
                                    {getFieldDecorator('shortName', {
                                        rules: [{
                                            message: '商户简称',
                                        }],
                                        initialValue: data.shortName
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="汇集日">
                                    {getFieldDecorator('collectionDay', {
                                        rules: [{
                                            required: true, message: '请选择汇集日',
                                        }],
                                        initialValue: data.collectionDay
                                    })(
                                        <Select
                                            showSearch
                                            disabled={true}
                                            placeholder="请选择汇集日"
                                            optionFilterProp={'children'}
                                        >
                                            {paymentDate.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol  label="首次汇集月份">
                                    {getFieldDecorator("_date", {
                                        rules: [{ required: true, message: "请选择首次汇集月份" }],
                                        initialValue: data.firstCollectionMonth?moment(data.firstCollectionMonth):null
                                    })(<DatePicker.MonthPicker placeholder="首次汇集月份" month   disabled={true}/>)}
                                </CustomCol>

                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="总期数">
                                    {getFieldDecorator('totalNumber', {
                                        rules: [{
                                            required: true, message: '请选择总期数',
                                        }],
                                        initialValue: data.totalNumber
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择总期数"
                                            disabled={true}
                                            optionFilterProp={'children'}
                                        >
                                            {totalNumberPeriods.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol  label="计划开始日期">
                                    {getFieldDecorator("_date", {
                                        rules: [{ required: true, message: "请选择首次汇集月份" }],
                                        initialValue: data.startDate?moment(data.startDate):null
                                    })(<DatePicker.MonthPicker placeholder="首次汇集月份" month   disabled={true}/>)}
                                </CustomCol>
                                <CustomCol  label="计划结束日期">
                                    {getFieldDecorator("_date", {
                                        rules: [{ required: true, message: "请选择首次汇集月份" }],
                                        initialValue: data.endDate?moment(data.endDate):null
                                    })(<DatePicker.MonthPicker placeholder="首次汇集月份" month   disabled={true}/>)}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol  label="是否贷款">
                                    {getFieldDecorator('loan', {
                                        rules: [{required: true, message: '请选择是否贷款'}],
                                        initialValue: data.loan
                                    })(
                                        <Radio.Group disabled={true}>
                                            <Radio value={false}>否</Radio>
                                            <Radio value>是</Radio>
                                        </Radio.Group>
                                    )}
                                </CustomCol>
                                <CustomCol label="入围贷款总额" subfix={<div>万</div>} subfixRight={10}>
                                    {getFieldDecorator('totalLoan', {
                                        rules: [{
                                            required: true, message: '请输入入围贷款总额',
                                        }],
                                        initialValue: data.totalLoan
                                    })(
                                        <InputNumber disabled={true}>
                                            placeholder={'请输入'}
                                            min={0}
                                        </InputNumber>
                                    )}
                                </CustomCol>

                            </CustomRow>
                            <DetailTitle title="租金汇集计划" />
                            <CustomRow divider>
                                <Table
                                    loading={loading}
                                    columns={columns}
                                    dataSource={dataSource}
                                    pagination={false}
                                />
                            </CustomRow>
                        </Col>
                    </Row>
                </Form>
            </div>
            <CollectionScheduleDetailedInfo
                onRef={ref => this.collectionScheduleDetailedInfoRef = ref}
                visible={showCollectionScheduleDetailedInfoModal}
                onlyRead={false}
                footer={<Button onClick={this.handleCancel}>关闭</Button>}
                handlecreateOrEdit={false}
                handleCancel={() => { this.setState({ showCollectionScheduleDetailedInfoModal: false }) }}
            />
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    handleCancel = () => { //关闭页面
        this.props.handleCancel();
        this.setState({  loading: false, title: "租金汇集计划详情" });
    }

    renderRow = (text, records, e) =>{
        if ( text=='查看详情') {
            return <a onClick={() => this.handleOpenInfo(records.periods)}>详情</a>
        }
        return text
    }

    handleOpenInfo = (periods) =>{
        console.log(periods);
        let merchantId=this.state.merchantId;
        console.log("商户Id=>"+merchantId);
        this.setState({ showCollectionScheduleDetailedInfoModal: true, createOrEdit: false, onlyRead: false })
        this.collectionScheduleDetailedInfoRef.loadPack({ merchantId,periods });
    }

    loadPack = ({ id ,shortName}) => {
        this.setState({ data:{shortName:shortName},loading: false,merchantId: id, title: "租金汇集计划详情" });
        postFrom({ url: config.API_Merchant_getMerchantCollectionScheduleCycleInfo, data: { merchantId: id } }).then(res => {
            const columns = res.titleList.map(e => ({title:e.value, dataIndex: e.key, render: (text, records) => this.renderRow(text, records, e)}))
            const dataSource = res.dataValueList;
            res.shortName=shortName;
            this.setState({ data: res,columns,dataSource, loading: false });
           // this.setState({ data: res, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });

    }



    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                let loginData = Cookies.get('loginData');
                if (loginData) {
                    loginData = JSON.parse(loginData);
                    values.merchantId = loginData.merchantId ? loginData.merchantId : 0;
                } else {
                    message.error('未登录')
                    return
                }

                // let { data: { splitAccount } } = this.state;
                this.setState({ loading: true });
                values.firstCollectionMonth = formatTime(values._date, "YYYY-MM");
                values.merchantId= this.state.merchantId;

                // if (values.id) {
                post({ url: config.API_Merchant_updateMerchantCollectionSchedule, data: values }).then(res => {
                    message.success('操作成功');
                    this.props.handleGetList();
                    this.handleCancel();
                }).catch(err => {
                    message.error(err.message || '操作失败');
                    this.setState({ loading: false });
                })

            }
        })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Merchant/components/CollectionScheduleDetailed/index.js